import {
    FEEDBACK_DIALOG_UPDATE_CONTENT,
    FEEDBACK_DIALOG_UPDATE_TITLE,
    FEEDBACK_DIALOG_UPDATE_DISPLAY_DIALOG,
    FEEDBACK_DIALOG_UPDATE_ERROR,
    FEEDBACK_DIALOG_RESET,
} from './types'

/**
 * @description update feedback dialog main title
 * @param {string} title main title
 * @returns {void}
 */
export const updateFeedbackDialogTitle = (title: any) => (dispatch: any) => {
    dispatch({
        type: FEEDBACK_DIALOG_UPDATE_TITLE,
        payload: {
            title,
        },
    })
}

/**
 * @description update feedback dialong content
 * @param {Object} { subtitle: string, text: string, files: Array<Files>, progress: number }
 * @returns {void}
 */
export const updateFeedbackDialogContent =
    ({ subtitle, text, files, progress }: any) =>
    (dispatch: any) => {
        dispatch({
            type: FEEDBACK_DIALOG_UPDATE_CONTENT,
            payload: {
                subtitle: subtitle || '',
                text: text || '',
                files: files || [],
                progress: progress || 0,
            },
        })
    }

/**
 * @description hide or show feedback dialog form
 * @param {boolean} display true = display, false = hide
 * @returns {void}
 */
export const displayFeedbackDialogContent = (display: any) => (dispatch: any) => {
    dispatch({
        type: FEEDBACK_DIALOG_UPDATE_DISPLAY_DIALOG,
        payload: {
            displayDialog: display,
        },
    })
}

/**
 * @description set errors on feedback dialog
 * @param {boolean} hasErrors true = errors, false = no errors
 * @returns {void}
 */
export const updateFeedbackDialogError = (hasErrors: any) => (dispatch: any) => {
    dispatch({
        type: FEEDBACK_DIALOG_UPDATE_ERROR,
        payload: {
            hasErrors,
        },
    })
}

/**
 * @description reset feedback dialog
 * @returns  {void}
 */
export const resetFeedbackDialog = () => (dispatch: any) => {
    dispatch({
        type: FEEDBACK_DIALOG_RESET,
    })
}
